var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutId',[_c('gdlFormDSL',{attrs:{"fields":_vm.fields,"init-data":_vm.resource.one,"readonly":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }